import { render, staticRenderFns } from "./MessagesWraper.vue?vue&type=template&id=f23c843c&scoped=true&"
import script from "./MessagesWraper.vue?vue&type=script&lang=js&"
export * from "./MessagesWraper.vue?vue&type=script&lang=js&"
import style0 from "./MessagesWraper.vue?vue&type=style&index=0&id=f23c843c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23c843c",
  null
  
)

export default component.exports